var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGuard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.287,
    height: 43.211,
    viewBox: "0 0 39.287 43.211",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Glyph",
    transform: "translate(-2 -1.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4917",
    "data-name": "Path 4917",
    d: "M36.671,4.2,22.92,1.135a6.207,6.207,0,0,0-2.554,0L6.616,4.2A5.893,5.893,0,0,0,2,9.955V17.95A27.638,27.638,0,0,0,19.542,43.8a5.5,5.5,0,0,0,2.1.413,5.893,5.893,0,0,0,2.1-.393A27.7,27.7,0,0,0,41.287,17.95V9.955A5.893,5.893,0,0,0,36.671,4.2Zm-5.7,14.006L21.526,27.5a1.964,1.964,0,0,1-2.77,0l-4.479-4.4a1.965,1.965,0,0,1,2.77-2.789l3.1,3.045,8.073-7.857a1.972,1.972,0,0,1,2.77,2.809Z",
    transform: "translate(0)",
    fill: "#24515e"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuard);
export default __webpack_public_path__ + "static/media/guard.68a545a06dbcbc7eaba214de731a08b2.svg";
export { ForwardRef as ReactComponent };